import { KeyboardEvent, ReactNode, useState } from 'react'
import { Box, Button, MenuItem, Select, TextField } from '@mui/material'
import type { ModelInfo } from 'chat-shared'

export const ChatInput = ({
  models,
  model,
  onModelChange,
  onSend,
  isStreaming,
  onAbort,
  statusIndicator,
}: {
  models: Array<ModelInfo>
  model: string
  onModelChange: (model: string) => void
  onSend: (content: string) => void
  isStreaming: boolean
  onAbort: () => void
  /** Rechts neben der Modellauswahl, z. B. der Kontext-Indikator. */
  statusIndicator?: ReactNode
}) => {
  const [value, setValue] = useState('')

  const submit = () => {
    const trimmed = value.trim()
    if (!trimmed || isStreaming) return
    onSend(trimmed)
    setValue('')
  }

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault()
      submit()
    }
  }

  return (
    <Box display="flex" flexDirection="column" gap={1} p={2} borderTop="1px solid" borderColor="divider">
      <Box display="flex" alignItems="center" justifyContent="space-between" gap={1}>
        <Select
          size="small"
          value={model}
          onChange={(e) => onModelChange(e.target.value)}
          sx={{ width: 260 }}
        >
          {models.map((m) => (
            <MenuItem key={m.id} value={m.id}>
              {m.label}
            </MenuItem>
          ))}
        </Select>
        {statusIndicator}
      </Box>
      <Box display="flex" gap={1}>
        <TextField
          fullWidth
          multiline
          maxRows={8}
          placeholder="Nachricht schreiben … (Enter senden, Shift+Enter neue Zeile)"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        {isStreaming ? (
          <Button variant="outlined" color="error" onClick={onAbort}>
            Stop
          </Button>
        ) : (
          <Button variant="contained" onClick={submit} disabled={!value.trim()}>
            Senden
          </Button>
        )}
      </Box>
    </Box>
  )
}
